module.exports = {"542225100":"琼结镇","542225200":"拉玉乡","542225201":"下水乡","542225202":"加麻乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542225.json
// module id = 2886
// module chunks = 0